import { render, staticRenderFns } from "./AddressFields.vue?vue&type=template&id=2c6054a4&"
import script from "./AddressFields.vue?vue&type=script&lang=js&"
export * from "./AddressFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports